<template>
  <dynamic-object-form-structure
    :object-uuid="objectUUID"
    :object-layer="objectLayer"
    :loading-structure="loadingStructure"
    :loading-save="loadingSave"
    :permission-name="form.permission"
    :object-type-translation-key="form.name_translation"
    :tabs="form.tabs"
    :active-tab="activeTab"
    :action-type="actionType"
    :saveIsDisabled="!required.filled"
    :map-element="$parent.$refs.formsContainer"
    :previous-pos-x="previousPosX"
    :previous-pos-y="previousPosY"
    :data-was-changed="dataWasChanged"
    :fields-still-need-filled="required.stillNeedFilled"
    @updateActiveTab="activeTab = $event"
    @changeViewMode="changeViewModeOfObject"
    @openDetails="openDetails"
    @refresh="refresh"
    @clearData="clearData"
    @save="saveObject"
    @close="closeForm"
  >
    <template v-slot:formFields>
      <div
        v-show="visibleTabs[activeTab].type === 'form'"
        class="form tab-content"
      >
        <template v-for="field in visibleTabs[activeTab].fields">
          <input-field
            v-if="field.var_name === 'cb_field_cable_type_options_id'"
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            inputType="other"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :hide="field.hide"
            :fieldDisabled="field.disable || !objectData.cb_field_cable_type_id"
            :formDisabled="readOnly"
          >
            <div>
              <treeselect
                :value="getValueInObject(field.var_name, field.input_type)"
                @input="
                  setValueInObject(field.var_name, $event, field.input_type)
                "
                :options="fieldCableTypeOptionsList"
                :normalizer="listElementNormalizer"
                :disabled="
                  readOnly ||
                    !userCanEditTabContent(visibleTabs[activeTab]) ||
                    field.disable ||
                    !objectData.cb_field_cable_type_id
                "
                class="form-input-select"
                disableFuzzyMatching
              />
            </div>
          </input-field>

          <input-field
            v-else-if="field.var_name === 'cb_field_reference_pole_id'"
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            inputType="other"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :hide="field.hide"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
          >
            <div>
              <treeselect
                :value="getValueInObject(field.var_name, field.input_type)"
                @input="
                  setValueInObject(field.var_name, $event, field.input_type)
                "
                :options="poleOptions"
                :normalizer="poleOptionsNormalizer"
                :disabled="
                  readOnly ||
                    !userCanEditTabContent(visibleTabs[activeTab]) ||
                    field.disable
                "
                class="form-input-select"
                disableFuzzyMatching
              />
            </div>
          </input-field>

          <input-field
            v-else
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            @input="setValueInObject(field.var_name, $event, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            :inputType="field.input_type"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :selectOptions="field.select_list_name"
            :radioOptions="field.radio_options"
            :constraints="field.constraints"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
            :hide="field.hide"
            :automatic-label="field.has_automatic_label"
            @generateLabel="getAutomaticLabel(autoLabelRequestData)"
            :checkboxOptions="field.checkbox_options"
            :object-data="objectData"
            @updateCheckboxValue="updateCheckboxValue($event)"
            @removePhoto="addToPhotosToRemove($event)"
          />
        </template>
      </div>
    </template>
  </dynamic-object-form-structure>
</template>

<script>
import { bus } from "@/main";
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import { listsMixin } from "@/mixins/listsMixin";
import DynamicObjectFormStructure from "../_Templates/DynamicObjectFormStructure";
import InputField from "../_Molecules/InputField";

export default {
  name: "FieldCableForm",

  components: {
    InputField,
    DynamicObjectFormStructure
  },

  mixins: [dynamicObjectFormsMixin, listsMixin],

  props: {
    lineStringWKT: {
      type: String
    },
    objectNodes: {
      type: Array
    }
  },

  data() {
    return {
      fieldCableTypeOptionsList: [],
      poleOptions: []
    };
  },

  watch: {
    "objectData.cb_field_cable_type_id"(newID, oldID) {
      if (newID === undefined) {
        this.objectData.cb_field_number_cables = null;
        this.objectData.cb_field_cable_type_id = null;

      } else if ((newID && oldID) || (oldID === null)) {
        this.objectData.cb_field_cable_type_options_id = undefined;

        this.fieldCableTypeOptionsList = this.$store.getters.optionLists_fieldCableTypeOptions.filter(
          option => {
            return option.field_cable_type_id === newID;
          }
        );
        if (this.fieldCableTypeOptionsList[0]) {
          let numberCables = this.fieldCableTypeOptionsList[0].number_cables;
          if (numberCables)
            this.objectData.cb_field_number_cables = numberCables;
        }
      }
    }
  },

  mounted() {
    this.fillPoleOptions();
  },

  methods: {
    createObject() {
      this.createDataToSend();

      let data = {
        endpoint: this.form.endpoint,
        data: [this.dataToSend]
      };
      this.CREATE_OBJECTS(data)
        .then(() => {
          bus.$emit("reset-line-string");
          this.finishObjectCreation();
        })
        .catch(error => {
          this.$toasted.global.toast_error(error.response.data.data);
          this.loadingSave = false;
        });
    },

    createDataToSend() {
      this.placeObjectDataInDataToSend();
      this.dataToSend.text_geom = this.lineStringWKT;
      this.dataToSend.projection = 3857;
      this.dataToSend.nodes = this.objectNodes;
      this.dataToSend.physical_type = "E";
    },

    fillPoleOptions() {
      this.poleOptions = [];
      if (this.actionType === "create") {
        this.objectNodes.forEach(node => {
          if (node.id !== null) {
            this.poleOptions.push({
              id: node.id,
              label: node.label
            });
          }
        });
      } else {
        if (this.dataReceived.children) {
          this.dataReceived.children.forEach(childCable => {
            if (childCable.cable_lines) {
              childCable.cable_lines.forEach(cableLine => {
                cableLine.technical_points.forEach(techPoint => {
                  let founded = this.poleOptions.find(option => {
                    return option.id === techPoint.tp_id;
                  });
                  if (!founded) {
                    this.poleOptions.push({
                      id: techPoint.tp_id,
                      label: techPoint.tp_label
                    });
                  }
                });
              });
            }
          });
        }
      }
    },

    poleOptionsNormalizer(node) {
      let label = node.label ? node.label : node.id;
      return {
        id: node.id,
        label: label
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/ObjectForms/FieldCableForm.vue